export var VERSION = '2.14.0';
//# sourceMappingURL=version.js.map